import React, { useEffect, useState } from "react";
import FilterSection from "./components/FilterSection";
import SelectSingleComponent from "../../components/SelectSingleComponent/SelectSingleComponent";
import { IconExpandMore, IconFilters } from "../../assets/icons";
import ProductGridList from "../../components/common/ProductGridList";
import { useParams, useSearchParams } from "react-router-dom";
import {
  ProductCategoriesEnums,
  ProductLabelsEnums,
} from "./enums/ProductsEnums";

const ProductsPage = () => {
  // States
  const { productCategory } = useParams();
  const [params] = useSearchParams();
  const search = params.get("search") || "";
  const defaultCategory = params.get("category");

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [order, setOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [filterOptions, setFilterOptions] = useState({
    category:
      productCategory && ProductCategoriesEnums[productCategory]
        ? [productCategory]
        : defaultCategory
        ? defaultCategory.split(",").map((cat) => cat.trim())
        : [],
  });

  const sortOptions = [
    { value: "", label: "Sắp xếp" },
    { value: "asc", label: "A -> Z" },
    { value: "desc", label: "Z -> A" },
  ];

  const handleOrderChange = (selectedOption) => {
    setOrder(selectedOption);
    setCurrentPage(1);
  };

  // USE EFFECT
  useEffect(() => {
    if (isFilterOpen) {
      document.body.style.overflow = "hidden"; // Ngừng cuộn
    } else {
      document.body.style.overflow = "auto"; // Khôi phục cuộn
    }

    // Cleanup khi component unmount hoặc filter đóng
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFilterOpen]);

  return (
    <div
      className="w-full lg:px-24 px-4 pt-8 lg:p-0 bg-white"
      style={{ minHeight: "calc(100vh - 21.5rem)" }}
    >
      {/* Breadcrumb */}
      {productCategory ? (
        <div className="hidden lg:flex items-center gap-2 pt-8 bg-white text-gray-600 text-sm">
          <a href="/products" className="hover:underline">
            Sản phẩm
          </a>
          <span>&gt;</span>
          <span className="font-semibold text-black">
            {ProductCategoriesEnums[productCategory] ??
              ProductLabelsEnums[productCategory]}
          </span>
        </div>
      ) : (
        <div className="lg:py-4"></div>
      )}

      {/* Content */}
      <div className="lg:grid lg:grid-cols-6 lg:gap-8 py-2">
        {/* Filter Sidebar for Desktop */}
        {!productCategory && (
          <div className="hidden lg:block lg:col-span-1 bg-white rounded-md">
            <FilterSection
              filterOptions={filterOptions}
              setFilterOptions={setFilterOptions}
            />
          </div>
        )}

        {/* Products Section */}
        <div className={productCategory ? "lg:col-span-6" : "lg:col-span-5"}>
          {/* Header with Filter and Sort */}
          <div className="flex flex-col lg:flex-row justify-between items-center  mb-0 mt-4 lg:mt-0">
            <div
              className="grid grid-cols-2 lg:flex fg:flex-row gap-4 fixed lg:static top-[5rem] left-0 z-20 w-full px-4 py-2 lg:p-0 bg-white justify-between
            border-b border-gray-100 lg:border-0"
            >
              {/* Mobile Filter Button */}
              {productCategory ? (
                <div className="flex flex-row items-end gap-2">
                  <span className="lg:hidden font-bold text-xl">
                    {ProductCategoriesEnums[productCategory]}
                  </span>
                </div>
              ) : (
                <button
                  className="lg:hidden bg-white border border-gray-300 px-4 py-2 rounded-md text-left flex justify-between"
                  onClick={() => setIsFilterOpen(true)}
                >
                  <span>Lọc</span>
                  <IconFilters />
                </button>
              )}

              {/* Sort Select Box */}
              <SelectSingleComponent
                options={sortOptions}
                selectedOption={order}
                onChange={handleOrderChange}
                // placeholder="Sắp xếp"
              />

              <div
                className={`text-gray-600 col-span-2 lg:order-first lg:col-span-1
                  ${
                    search ? "block lg:visible" : "hidden lg:block lg:invisible"
                  }
                  `}
              >
                Kết quả tìm kiếm cho "
                <span className="font-semibold text-black">{search}</span>"
              </div>
            </div>
          </div>

          <ProductGridList
            className={search ? "mt-12 lg:mt-0" : "mt-4 lg:mt-0"}
            gridClassName="grid gap-4 grid-cols-2 lg:grid-cols-5 grid-rows-4 lg:grid-rows-2 lg:p-0"
            order={order}
            page={currentPage}
            filterOptions={filterOptions}
            label={
              ProductCategoriesEnums[productCategory] ? "" : productCategory
            }
            search={search}
          />
        </div>
      </div>

      {/* Mobile Filter Panel */}
      {isFilterOpen && (
        <div className="lg:hidden fixed top-[5rem] inset-0 z-50 bg-white p-4 flex flex-col gap-4 border-t">
          <div className="flex items-center justify-start gap-2">
            <button onClick={() => setIsFilterOpen(false)}>
              <IconExpandMore className="w-8 h-8 rotate-90 fill-black" />
            </button>
            <span className="text-2xl font-medium">Bộ lọc</span>
          </div>
          <FilterSection
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
          />
          <button
            className="w-full bg-black text-white px-4 py-2 mt-4 rounded-md"
            onClick={() => setIsFilterOpen(false)}
          >
            Đóng
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductsPage;
